import React from "react";
import { SlideManager } from "components/organisms/CommonUI/SlidePopup/SlideManager";
import { DosePromptRef } from "services/api/doseRules/types";
import PromptTextsSlideContent from "./PromptTextsSlideContent";

/**
 * 우측 슬라이드로 "보낸 전문"(추출 프롬프트 원문)을 연다(openDoseReviewTestSlide 패턴).
 * width 800px · 배경 있음. 호출마다 고유 key를 붙여, 닫는 애니메이션 도중 다시 열려도
 * 이전 쿼리/상태가 재사용되지 않게 한다. 단계(STEP2/STEP3)마다 1개 버튼이 이 함수를 부른다.
 *
 * @spec:2026-09-30-처방검토-룰추출-프롬프트-버전관리-스냅샷
 */
export type PromptTextsStep = "STEP2" | "STEP3";

let openSeq = 0;

export interface OpenPromptTextsSlideParams {
  step: PromptTextsStep;
  ruleId: string;
  promptRef: DosePromptRef;
  isDerived: boolean;
  derivedFrom: string | null;
}

export function openPromptTextsSlide(params: OpenPromptTextsSlideParams) {
  const key = `prompt-texts-${++openSeq}`;
  SlideManager.show({
    body: <PromptTextsSlideContent key={key} {...params} />,
    width: "800px",
    needCloseButton: true,
    direction: "right",
  });
}
